var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
export var Label = function (_a) {
    var htmlFor = _a.htmlFor, required = _a.required, className = _a.className, children = _a.children;
    return (React.createElement("label", { htmlFor: htmlFor, className: clsx(className, 'px-1 text-p leading-5 transition-all duration-300') },
        children,
        required && React.createElement("abbr", { title: "Obligatoriskt" }, "*")));
};
export var ErrorSpan = function (_a) {
    var fieldId = _a.fieldId, invalid = _a.invalid, children = _a.children, props = __rest(_a, ["fieldId", "invalid", "children"]);
    return (React.createElement("label", __assign({ id: "form" + fieldId + "__desc", "aria-live": "polite", hidden: !invalid }, props, { className: "block px-1 text-p leading-5 transition-all duration-300 text-red" }), children));
};
